module.exports = "/packs/images/svg/facilities/drop_in~22de02f9b2ba0f496b3607d1458e3124.svg";